import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';
import { FocClear } from '~/components/Patient';
import { gapIsAddressed, gapIsUnderReview } from '~/util';

const propTypes = {
    focGap: PropTypes.shape().isRequired,
    rolePermission: PropTypes.bool.isRequired,
    formDirty: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    formId: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    setDisabled: PropTypes.func.isRequired,
    saving: PropTypes.bool.isRequired,
    tab: PropTypes.string.isRequired,
    patientId: PropTypes.number.isRequired,
};

export function FocGapModalFooter({
    focGap,
    rolePermission,
    formDirty,
    handleClose,
    formId,
    disabled,
    setDisabled,
    saving,
    tab,
    patientId,
}) {
    const hasSave =
        !rolePermission || gapIsAddressed(focGap) || gapIsUnderReview(focGap) ? false : formDirty;

    return (
        <>
            <button className="btn btn-secondary" type="button" onClick={handleClose}>
                {hasSave ? 'Cancel' : 'Close'}
            </button>
            <FocClear
                rolePermission={rolePermission}
                tab={tab}
                patientId={patientId}
                disabled={disabled}
                setDisabled={setDisabled}
                onSuccess={handleClose}
                focGap={focGap}
            />
            {hasSave && (
                <button className="btn btn-primary" type="submit" form={formId} disabled={disabled}>
                    {saving && (
                        <Spinner animation="border" role="status" size="sm" className="me-1" />
                    )}
                    Save
                </button>
            )}
        </>
    );
}

FocGapModalFooter.propTypes = propTypes;
